import { Description, Environment, Name, RedirectUrls } from 'app/dashboard/application/applicationForm/fields';
import { AccountsContext } from 'context/accounts/AccountsContext';
import { ApplicationsContext } from 'context/applications/ApplicationsContext';
import { FormApi } from 'final-form';
import React, { useContext, useState } from 'react';
import { Certifications, LocaleContext, ModalForm, NotificationsContext, NotificationTypes } from 'shared';
import { Account, AddApplicationPayload, ApplicationSimple } from 'store/api/types';

import { AddTppLogo } from '../../../../shared/logo/AddTppLogo';
import { getEnvironmentVar } from '../../../../utils';
import { getErrorMessage } from '../../../../utils/getErrorMessage/getErrorMessage';

import { AddApplicationProps } from './AddApplication.types';

export const AddApplication = ({ onAddApplication, onClose, isOpen }: AddApplicationProps) => {
  const accountsContext = useContext(AccountsContext);
  const applicationsContext = useContext(ApplicationsContext);
  const localeContext = useContext(LocaleContext);
  const notificationsContext = useContext(NotificationsContext);
  const activeAccount = accountsContext.activeAccount as Account;
  const isLogoEnabled = getEnvironmentVar('REACT_APP_LOGO_ENABLED') === 'true';
  const [qwacFileName, setQwacFileName] = useState('');
  const [qsealcFileName, setQsealcFileName] = useState('');

  const handleSubmit = async (values: AddApplicationPayload, form: FormApi) => {
    try {
      const payload = {
        qsealcCertificateFileName: qsealcFileName,
        qwacCertificateFileName: qwacFileName,
        ...values,
        redirectUris: values.redirectUris ? values.redirectUris.map((entry: any) => entry.label) : [],
      };

      return await onAddApplication(activeAccount.uuid)(payload, form, results => {
        const application = results.payload as ApplicationSimple;

        form.reset();
        onClose();

        applicationsContext.addApplication({
          createdAt: new Date().toISOString(),
          description: values.description as string,
          environment: values.environment as string,
          name: values.name as string,
          refId: null,
          uuid: application.uuid,
        });

        notificationsContext.showNotification({
          message: localeContext.formatMessage({ id: 'APPLICATION.FORM.ADD-SUCCESS' }),
          time: 1000,
          type: NotificationTypes.SUCCESS,
        });
      });
    } catch (error) {
      notificationsContext.showNotification({
        message: getErrorMessage(error, localeContext),
        time: 1000,
        type: NotificationTypes.ERROR,
      });
    }
  };

  return (
    <ModalForm
      className="application-form"
      name={localeContext.formatMessage({ id: 'APPLICATION.FORM.CREATE-NEW-APP' }, { accountName: activeAccount.name })}
      submitName={localeContext.formatMessage({ id: 'GENERAL.SAVE' })}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      initialValues={{
        environment: 'SANDBOX',
      }}
      subscription={{ submitting: true }}
    >
      <Environment options={['SANDBOX', 'PRODUCTION']} />
      <Name />
      <Description />
      <RedirectUrls />
      <Certifications setQsealcFileName={setQsealcFileName} setQwacFileName={setQwacFileName} />
      {isLogoEnabled ? <AddTppLogo /> : <div />}
    </ModalForm>
  );
};
